import React, { useState } from "react";
import { useGetPR01byDateRange } from "./useGetPR01byDateRange";
import styled from "styled-components";
import ListNeu from "../../interface/ListNeu";
import { useGetFilterList } from "./useGetFilterList";
import ButtonNeu from "../../interface/ButtonNeu";
import {
  MdOutlinePlaylistAdd,
  MdOutlinePlaylistAddCheck,
  MdOutlinePlaylistRemove,
  MdOutlineList,
} from "react-icons/md";
import { useAddFilter } from "./useAddFilter";
import { useDebounce } from "../../hooks/useDebounce";
import { useDeleteFilter } from "./useDeleteFilter";

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100rem;
`;

const LeftColumn = styled.div`
  flex: 1;
  padding: 1rem;
`;

const RightColumn = styled.div`
  flex: 1;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const InputBox = styled.input`
  padding: 0.5rem;
  border: none;
  border-radius: 10px;
  box-shadow: var(--shadow-main);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.13);
  font-size: 1em;
  flex-grow: 1;
`;

const ButtonContainer = styled.div`
  display: inline-flex;
  margin-top: 1rem;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
`;

const ListContainer = styled.div`
  margin-top: 1rem;
  margin-left: 1rem;
  height: 50rem;
  flex: 1;
  overflow: auto;
`;

const Label = styled.label`
  font-size: 1em;
  white-space: nowrap;
`;

function FilterEdit() {
  const [baseDate, setBaseDate] = useState(new Date());
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedFault, setSelectedFault] = useState("");

  const debouncedLocation = useDebounce(selectedLocation, 500);
  const debouncedFault = useDebounce(selectedFault, 500);

  const { mutate: mutateFilter } = useAddFilter();
  const { mutate: mutateDeleteFilter } = useDeleteFilter();

  const startDate = new Date(baseDate);
  startDate.setDate(baseDate.getDate() - 7); // Adjust to your logic for week start
  const endDate = new Date(baseDate);

  const { data, isLoading, isError, error } = useGetPR01byDateRange(
    startDate,
    endDate
  );

  const {
    data: FilterData,
    isLoadingFilter,
    isErrorFilter,
    errorFilter,
  } = useGetFilterList(debouncedLocation, debouncedFault);

  const handleRowClick = (item) => {
    setSelectedLocation(item.location);
    setSelectedFault(item.fault);
  };

  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };

  const handleFaultChange = (event) => {
    setSelectedFault(event.target.value);
  };

  const handleDelete = (item) => {
    console.log("Delete item", item);
    mutateDeleteFilter(
      {
        location: item.locationRaw,
        faultInfo: item.faultInfo,
      },
      {
        onSuccess: (data) => {
          console.log("Delete successful for", item, data);
        },
        onError: (error) => {
          console.error("Delete failed", error.message);
        },
      }
    );
  };

  const handleAddFilter = () => {
    mutateFilter({
      location: selectedLocation,
      faultInfo: selectedFault,
    });
  };

  const headings = [
    { key: "occurredCounter", label: "Count" },
    { key: "location", label: "Location" },
    { key: "fault", label: "Fault" },
  ];

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {error.message}</div>;

  FilterData && console.log("FilterData", FilterData);

  return (
    <Container>
      <LeftColumn>
        <ListNeu
          data={data ? data.data : []}
          headings={headings}
          onRowClick={handleRowClick}
        />
        <ButtonContainer>
          <ButtonNeu
            icon={<MdOutlineList />}
            onClick={() => setSelectedFault("")}
          >
            Reset Fault Filter
          </ButtonNeu>
          <ButtonNeu
            icon={<MdOutlineList />}
            onClick={() => setSelectedLocation("")}
          >
            Reset Location Filter
          </ButtonNeu>
        </ButtonContainer>
      </LeftColumn>

      <RightColumn>
        <InputContainer>
          <Label>Location</Label>
          <InputBox
            type="text"
            value={selectedLocation}
            onChange={handleLocationChange}
            placeholder="Location"
          />
        </InputContainer>

        <InputContainer>
          <Label>Fault</Label>
          <InputBox
            type="text"
            value={selectedFault}
            onChange={handleFaultChange}
            placeholder="Fault"
          />
        </InputContainer>
        <ButtonContainer>
          <ButtonNeu onClick={handleAddFilter} icon={<MdOutlinePlaylistAdd />}>
            Add Filter
          </ButtonNeu>
          <ButtonNeu
            onClick={handleDelete}
            icon={<MdOutlinePlaylistRemove />}
            $variation="danger"
          >
            Delete Filter
          </ButtonNeu>
          <ButtonNeu icon={<MdOutlinePlaylistAddCheck />}>
            Update Priority
          </ButtonNeu>
        </ButtonContainer>

        <ListContainer>
          <h3>Existing Filters matching parameters</h3>
          <ListNeu
            data={FilterData || []}
            headings={[
              { key: "locationRaw", label: "Location" },
              { key: "faultInfo", label: "Fault" },
            ]}
            onDelete={handleDelete}
          />
        </ListContainer>
      </RightColumn>
    </Container>
  );
}

export default FilterEdit;
